import { render, staticRenderFns } from "./page_reservation.vue?vue&type=template&id=5d48eee2&"
import script from "./page_reservation.vue?vue&type=script&lang=js&"
export * from "./page_reservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports